// @ts-check
import { takeEvery, put } from 'redux-saga/effects';
import { showModal } from 'shared/actions/UnboundModalActions';
import { NEW_REFERRAL_BUTTON_CLICKED } from '../actions/NewReferralActions';

function* handleNewReferralClick() {
  yield put(showModal({ name: 'newReferralTypeModal' }));
}

export default function* referralTypeSelectionSaga() {
  yield takeEvery(NEW_REFERRAL_BUTTON_CLICKED, handleNewReferralClick);
}
